import {BaseConverter} from '../../base/converters/base-converter.converter';
import {TreeUnitResearchModel} from '../models/tree-unit-research.model';
import {TreeUnitResearch} from '../DTO/treeUnitResearch';
import {Injectable} from '@angular/core';
import {TreeUnitResearchFilterConverter} from './tree-unit-research-filter.converter';
import {TreeUnitResearchOptionsConverter} from './tree-unit-research-options.converter';

@Injectable()
export class TreeUnitResearchConverter extends BaseConverter<TreeUnitResearchModel, TreeUnitResearch> {

  constructor(private treeUnitResearchFilterConverter: TreeUnitResearchFilterConverter, private treeUnitResearchOptionsConverter: TreeUnitResearchOptionsConverter) {
    super();
  }

  convertToDto(model: TreeUnitResearchModel): TreeUnitResearch {
    if (!model) {
      return;
    }
    return {
      filter: this.treeUnitResearchFilterConverter.convertToDto(model.filter),
      options: this.treeUnitResearchOptionsConverter.convertToDto(model.options)
    };
  }

  convertToModel(dto: TreeUnitResearch): TreeUnitResearchModel {
    if (!dto) {
      return;
    }
    let model = new TreeUnitResearchModel();
    model.options = this.treeUnitResearchOptionsConverter.convertToModel(dto.options);
    model.filter = this.treeUnitResearchFilterConverter.convertToModel(dto.filter);
    return model;
  }

}
